import type { SxProps, Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

import { EM_DASH } from './constants';

interface TruncatedCellProps {
  text: string;
  emptyValue?: ReactNode;
  sx?: SxProps<Theme>;
}

export function TruncatedCell({ text, emptyValue = EM_DASH, sx }: TruncatedCellProps) {
  if (!text) {
    return (
      <Typography variant="body2" sx={sx}>
        {emptyValue}
      </Typography>
    );
  }

  return (
    <Tooltip title={text}>
      <Typography
        variant="body2"
        sx={{
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          ...sx,
        }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
}

interface JoinedListCellProps {
  items: string[] | null | undefined;
  separator?: string;
  emptyValue?: ReactNode;
  sx?: SxProps<Theme>;
}

export function JoinedListCell({
  items,
  separator = ' | ',
  emptyValue = EM_DASH,
  sx,
}: JoinedListCellProps) {
  const text = items?.length ? items.join(separator) : '';
  return <TruncatedCell text={text} emptyValue={emptyValue} sx={sx} />;
}
